import React from 'react';

import { config } from 'components/pages/Epg/config';
import { useLocalTime } from 'hooks';

import styles from './TimeItem.module.scss';

interface Props {
  index: number;
  callBack: any;
  time: number;
}

function TimeItem({ time, index, callBack }: Props){
  const result = useLocalTime(time);

  return (
    <div
      aria-label={result}
      data-time={time}
      className={styles.item}
      data-index={index}
      style={{
        width: config.hourScale,
      }}
      onClick={callBack}
      role='button'
      tabIndex={0}
    >
      <span aria-hidden>{result}</span>
    </div>
  )
}

export default TimeItem;
